const MIME_EXTENSION_FALLBACKS: Array<[string, string]> = [
  ["application/pdf", "PDF"],
  ["application/msword", "DOC"],
  ["application/vnd.openxmlformats-officedocument.wordprocessingml.document", "DOCX"],
  ["text/plain", "TXT"],
  ["application/vnd.ms-excel", "XLS"],
  ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "XLSX"],
  ["application/vnd.ms-powerpoint", "PPT"],
  ["application/vnd.openxmlformats-officedocument.presentationml.presentation", "PPTX"],
];

export const getNewsFileExtension = (name?: string, mime?: string): string => {
  const cleanName = String(name || "").split("?")[0].split("#")[0];
  const dotIndex = cleanName.lastIndexOf(".");
  if (dotIndex > -1 && dotIndex < cleanName.length - 1) {
    const extension = cleanName.slice(dotIndex + 1).trim().toUpperCase();
    if (extension) return extension.slice(0, 6);
  }

  const normalizedMime = String(mime || "").toLowerCase();
  const fallback = MIME_EXTENSION_FALLBACKS.find(([candidate]) =>
    normalizedMime.includes(candidate),
  );
  return fallback?.[1] || "FILE";
};

export const getNewsFileDisplayName = (name?: string): string => {
  const cleanName = String(name || "").split("?")[0].split("#")[0].trim();
  if (!cleanName) return "Загруженный файл";

  const dotIndex = cleanName.lastIndexOf(".");
  if (dotIndex <= 0 || dotIndex === cleanName.length - 1) {
    return cleanName;
  }

  return cleanName.slice(0, dotIndex);
};
